import React, { useEffect, useState, useRef } from "react";
import { useAuth } from "../../context/AuthContext";
import { FaSpinner } from "react-icons/fa";
import background from "../../image/fondo_nubes.jpg";

const VerificationOTP = () => {
  const { requestOtp, verifyOtpCode, userCorreo } = useAuth();
  const [loading, setLoading] = useState(false);
  const [otp, setOtp] = useState(["", "", "", "", "", ""]);
  const [timeLeft, setTimeLeft] = useState(120); // 2 minutos
  const [resendAvailable, setResendAvailable] = useState(false);
  const inputsRef = useRef([]);

  useEffect(() => {
    // Enfocar el primer input al cargar la página
    inputsRef.current[0]?.focus();

    const timer = setInterval(() => {
      setTimeLeft((prev) => {
        if (prev <= 1) {
          setResendAvailable(true);
          clearInterval(timer);
        }
        return prev - 1;
      });
    }, 1000);
    return () => clearInterval(timer);
  }, []);

  const handleChange = (e, index) => {
    const value = e.target.value;
    if (value.match(/^[0-9]$/)) {
      const newOtp = [...otp];
      newOtp[index] = value;
      setOtp(newOtp);
      if (index < 5) {
        inputsRef.current[index + 1]?.focus(); // Mover al siguiente input
      }
    } else if (value === "") {
      const newOtp = [...otp];
      newOtp[index] = "";
      setOtp(newOtp);
    }
  };

  const handleBackspace = (e, index) => {
    if (e.key === "Backspace") {
      if (otp[index] === "" && index > 0) {
        inputsRef.current[index - 1]?.focus();
        const newOtp = [...otp];
        newOtp[index - 1] = "";
        setOtp(newOtp);
      } else {
        const newOtp = [...otp];
        newOtp[index] = "";
        setOtp(newOtp);
      }
    }
  };

  const handlePaste = (e) => {
    e.preventDefault();
    const pasteData = e.clipboardData.getData("text").trim().slice(0, 6); // Solo permite los primeros 6 dígitos
    const newOtp = [...otp];

    for (let i = 0; i < pasteData.length; i++) {
      if (i < 6 && pasteData[i].match(/^[0-9]$/)) {
        newOtp[i] = pasteData[i];
      }
    }

    setOtp(newOtp);
    const nextEmptyInput = newOtp.findIndex((digit) => digit === "");
    inputsRef.current[nextEmptyInput >= 0 ? nextEmptyInput : 5]?.focus(); // Enfoca el siguiente input vacío
  };

  const handleSubmit = async () => {
    const otpCode = otp.join("");
    try {
      await verifyOtpCode(userCorreo, otpCode);
    } catch (error) {
    } finally {
      setLoading(false);
    }
  };

  const handleResendOtp = async () => {
    await requestOtp(userCorreo);
    setTimeLeft(120);
    setResendAvailable(false);
  };

  return (
    <div className="relative flex justify-center items-center min-h-screen text-white p-4">
      {/* Imagen de fondo con opacidad */}
      <div
        className="absolute inset-0 bg-cover bg-center opacity-70 bg-black/50"
        style={{ backgroundImage: `url(${background})` }}
      ></div>
      {/* Overlay oscuro con opacidad */}
      <div className="absolute inset-0 bg-black/50"></div>
      <div className="relative w-full max-w-md bg-main-bg-sidebar p-8 rounded-2xl shadow-2xl text-center">
        <h2 className="text-3xl font-bold mb-4 text-gray-800">
          Verificación OTP
        </h2>
        <p className="text-gray-600 mb-4">
          Ingrese el código de 6 dígitos enviado a:{" "}
          <strong>{userCorreo}</strong>
        </p>
        <div className="flex gap-2 justify-center mb-6 flex-grap">
          {otp.map((digit, index) => (
            <input
              key={index}
              ref={(el) => (inputsRef.current[index] = el)}
              type="text"
              maxLength="1"
              value={digit}
              onChange={(e) => handleChange(e, index)}
              onKeyDown={(e) => handleBackspace(e, index)}
              onPaste={handlePaste}
              className="w-10 h-10 sm:w-12 sm:h-12 text-center text-black text-xl border-[2px] border-gray rounded-md focus:outline-none focus:ring-2 focus:ring-blue-200"
            />
          ))}
        </div>
        <div className="flex justify-center">
          <button
            onClick={handleSubmit}
            className="w-[20rem] bg-white text-black font-semibold p-3 rounded-full hover:bg-slate-200 transition"
          >
            {loading ? (
              <FaSpinner className="animate-spin mr-2" />
            ) : (
              "Verificar Código"
            )}
          </button>
        </div>

        <p className="mt-4">
          {resendAvailable ? (
            <button
              onClick={handleResendOtp}
              className="text-white underline hover:text-black p-2 rounded-full transition"
            >
              {loading ? (
                <FaSpinner className="animate-spin mr-2" />
              ) : (
                "Reenviar Código"
              )}
            </button>
          ) : (
            `El código expira en: ${Math.floor(timeLeft / 60)}:${(timeLeft % 60)
              .toString()
              .padStart(2, "0")}`
          )}
        </p>
      </div>
    </div>
  );
};

export default VerificationOTP;
